import { ApiBlueprint, createFrontendPlugin, discoveryApiRef, fetchApiRef } from '@backstage/frontend-plugin-api';
import { externalResourcesApiRef } from '@teamsystem/backstage-plugin-external-resources-react';
import { ExternalResourcesClient } from './api';
import { rootRouteRef } from './routes';

const externalResourcesApi = ApiBlueprint.make({
  params: defineParams => 
    defineParams({
      api: externalResourcesApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ExternalResourcesClient({ discoveryApi, fetchApi }),
    }),
});

export default createFrontendPlugin({
  pluginId: 'external-resources',
  routes: {
    root: rootRouteRef,
  },
  extensions: [
    externalResourcesApi,
  ],
});